var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightCheckBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#1A1645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1405 83.9295C51.4717 83.9298 50.8096 83.7967 50.1929 83.538C49.5761 83.2794 49.0171 82.9004 48.5485 82.4233L29.9591 63.5315C28.0095 61.5466 28.0346 58.3628 30.0195 56.4081C32.0045 54.4636 35.1933 54.4836 37.143 56.4686L51.9945 71.5617L82.72 37.7229C84.599 35.6625 87.7831 35.5165 89.8333 37.3804C91.8937 39.2495 92.0448 42.4333 90.1758 44.4988L55.8685 82.282C55.4081 82.7896 54.849 83.198 54.2253 83.4821C53.6016 83.7662 52.9266 83.9201 52.2414 83.9344C52.2061 83.9295 52.1759 83.9295 52.1405 83.9295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCheckBlue);
export default __webpack_public_path__ + "static/media/right-check-blue.45946f5435c93a665fd35812ae1c49e9.svg";
export { ForwardRef as ReactComponent };